import { Component, Input, DOCUMENT, ChangeDetectionStrategy, inject, input } from '@angular/core';

@Component({
	selector: 'vex-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
	host: {
		class: 'vex-sidebar',
	},
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class SidebarComponent {
	private document = inject<Document>(DOCUMENT);

	readonly position = input<'left' | 'right'>('left');
	readonly invisibleBackdrop = input<boolean>(undefined);

	private _opened: boolean;

	get opened() {
		return this._opened;
	}

	@Input() set opened(opened: boolean) {
		this._opened = opened;
		opened ? this.enableScrollblock() : this.disableScrollblock();
	}

	get positionLeft() {
		return this.position() === 'left';
	}

	get positionRight() {
		return this.position() === 'right';
	}

	enableScrollblock() {
		if (!this.document.body.classList.contains('vex-scrollblock')) {
			this.document.body.classList.add('vex-scrollblock');
		}
	}

	disableScrollblock() {
		if (this.document.body.classList.contains('vex-scrollblock')) {
			this.document.body.classList.remove('vex-scrollblock');
		}
	}

	open() {
		this.opened = true;
	}

	close() {
		this.opened = false;
	}
}
